'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _Dashboard = _interopRequireDefault(require("Components/Lists/Dashboard"));
var _ProjectRow = _interopRequireDefault(require("../Components/Lists/Rows/ProjectRow"));
var _Routing = require("Functions/Routing");
var _ChatRow = _interopRequireDefault(require("Components/Lists/Rows/ChatRow"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const WelcomePage = props => {
  const {
    name,
    firstname,
    roles
  } = app.state.session.user;
  const screenWidth = window.screen.width;
  const projectListHeader = [{
    name: 'id',
    label: 'Dossier'
  }, {
    name: 'created_at',
    label: 'Date de chirurgie'
  }, {
    name: 'stl_type',
    label: 'STL'
  }, {
    name: 'created_by',
    label: 'Praticien'
  }];
  const projectListfields = projectListHeader.map(infos => infos.name);
  const chatListHeader = [{
    name: 'pratician',
    label: 'Praticien '
  }, {
    name: 'related_project',
    label: 'Dossier'
  }, {
    name: 'updated_at',
    label: 'Date du dernier message'
  }];
  if (roles[0] === "deltex") {
    chatListHeader.push({
      name: 'read_by_deltex',
      label: 'Message'
    });
  }
  if (roles[0] === "pratician") {
    delete projectListHeader[3];
    delete chatListHeader[0];
    chatListHeader.push({
      name: 'read_by_pratician',
      label: 'Message'
    });
  }
  if (screenWidth < 1200) {
    delete chatListHeader[0];
    delete chatListHeader[2];
    delete projectListHeader[2];
    delete projectListHeader[3];
  }
  const chatListfields = chatListHeader.map(infos => infos.name);
  let orthoFilter = {};
  if (roles[0] === 'ortho') {
    orthoFilter = {
      shared_with: app.state.session.user.login
    };
  } else undefined;
  return /*#__PURE__*/_react.default.createElement(_Back.default, (0, _extends2.default)({
    page_title: "Accueil"
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "o-content u-margin-top-10 welcome_page"
  }, roles[0] === "deltex" ? /*#__PURE__*/_react.default.createElement("p", null, "Bonjour ", name) : /*#__PURE__*/_react.default.createElement("p", null, "Bonjour ", firstname, " ", name), roles[0] === "ortho" ? undefined : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, roles[0] === "pratician" ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    href: (0, _Routing.URL)('NewProject'),
    className: (0, _bemit.default)('c-flat-btn', ['primary'])
  }, "Nouvelle demande") : undefined, /*#__PURE__*/_react.default.createElement("h2", null, "Les 5 derniers \xE9changes :"), /*#__PURE__*/_react.default.createElement("div", {
    className: "dashboard-table u-margin-bottom-25",
    style: {
      overflow: 'initial'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding"
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "User",
    url: (0, _Routing.action)('getAllMessages'),
    header: chatListHeader,
    fields: chatListfields,
    component: _ChatRow.default,
    "items-per-page": 5,
    filters: {
      limit: 5
    },
    order: "desc",
    "order-by": "updated_at"
  })))), /*#__PURE__*/_react.default.createElement("h2", null, "Les 5 derniers dossiers :"), /*#__PURE__*/_react.default.createElement("div", {
    className: "dashboard-table u-margin-bottom-25",
    style: {
      overflow: 'initial'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding"
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "Project",
    url: (0, _Routing.action)('getAllProjects'),
    header: projectListHeader,
    fields: projectListfields,
    component: _ProjectRow.default,
    "items-per-page": 5,
    filters: _objectSpread({
      limit: 5
    }, orthoFilter)
  })))));
};
var _default = exports.default = WelcomePage;
